/** @format */

export enum Workspace {
  EBIO = 'ebio', // (gtb)
  AXIO = 'axio', // (gmao)
  MY_SESIO = 'my-sesio',
  NETWORK = 'network',
  CONSOLE = 'console',
}

export const WorkspaceVisibility: Record<Workspace, boolean> = {
  [Workspace.EBIO]: true,
  [Workspace.AXIO]: true,
  [Workspace.MY_SESIO]: true,
  [Workspace.NETWORK]: false,
  [Workspace.CONSOLE]: false,
};
